var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShowmoreTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.666 8.5A6.674 6.674 0 018 15.167 6.674 6.674 0 011.333 8.5 6.674 6.674 0 018 1.833 6.674 6.674 0 0114.666 8.5z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.813 7.538a.498.498 0 01-.146.353l-2.313 2.325a.501.501 0 01-.709 0L5.33 7.89a.5.5 0 11.71-.705L8 9.154l1.96-1.968a.5.5 0 01.853.352z",
    fill: "#333"
  })));
}

export default SvgIconShowmoreTask;